import GearFilled from '../../src/legacy/GearFilled';
export default GearFilled;
